export default {
  CITY: 'city',
  COUNTRY: 'country',
};



// WEBPACK FOOTER //
// ./src/shared/constants/locationTypes.js